import React, { Component } from 'react';
import { get, update, remove, push, clone, post } from '../util/Utility.js';
import { CCOButton, CCOAlert } from '../util/Components';
import { ControlLabel, FormGroup, Modal, FormControl, Checkbox } from 'react-bootstrap';

export default class CollectionEditView extends Component {

  constructor(props) {
    super(props);

    this.state = {
      collections: clone(window.sermon_collections),
      newCollectionTitle: "",
      newCollectionImage: "",
      newCollectionArtwork: "",
      newCollectionSeries: false,
      newCollectionPriority: 3,
      collection: null,
      featured: ""
    }
  }

  componentDidMount() {
    get("sermon_collections/featured", this, null, null, false).then(featured => this.setState({featured}));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }

  updateDimensions() {
    this.setState({width: window.innerWidth});
  }

  componentWillMount() {
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }

  resetSections() {
    this.setState({sections: Object.keys(this.state.collections).map(item => { return {title: this.state.collections[item].name, filter: e => e.collection === item}})});
  }

  saveNewCollection() {
    let newObj = {name: this.state.newCollectionTitle, image: this.state.newCollectionImage, artwork: this.state.newCollectionArtwork, series: this.state.newCollectionSeries, priority: this.state.newCollectionPriority};
    push('sermon_collections', this, newObj).then(newObj => {
      let collections = this.state.collections;
      collections[newObj.key] = newObj;
      this.setState({collections, newCollectionTitle: "", newCollectionImage: "", newCollectionArtwork: "", newCollectionSeries: false, newCollectionPriority: 3});
      window.sermon_collections = collections;
    });
  }

  saveCollections() {

    if (this.state.newCollectionTitle !== "") {
      this.saveNewCollection();
    }

    Object.keys(this.state.collections).forEach(key => {
      if (window.sermon_collections[key]) {
        if (JSON.stringify(window.sermon_collections[key]) !== JSON.stringify(this.state.collections[key])) {
          update('sermon_collections/' + key, this, this.state.collections[key]);
        }
      } else {
        push('sermon_collections', this, this.state.collections[key]);
      }
    });

    window.sermon_collections = clone(this.state.collections);
    this.props.done(this.state.sermon_collections);
  }

  render() {

    var collectionRows = Object.keys(this.state.collections).map((key, i) => {
      return (
        <tr key={i}><td><p>{i + 1}</p></td>
          <td><FormControl readOnly={key === "none"} type="text" onChange={function(e) {
            let collections = this.state.collections;
            collections[key].name = e.target.value;
            this.setState({collections});
          }.bind(this) } value={this.state.collections[key].name} placeholder="Enter Collection Name" /></td>
          <td><FormControl componentClass="select" onChange={function(e) {
            let collections = this.state.collections;
            collections[key].priority = parseInt(e.target.value);
            this.setState({collections});
          }.bind(this) } value={this.state.collections[key].priority} placeholder="Priority"><option>1</option><option>2</option><option>3</option></FormControl></td>
          <td><FormControl type="text" onChange={function(e) {
            let collections = this.state.collections;
            collections[key].image = e.target.value;
            this.setState({collections});
          }.bind(this) } value={this.state.collections[key].image} placeholder="Enter Full URL" /></td>
          <td><FormControl type="text" onChange={function(e) {
            let collections = this.state.collections;
            collections[key].artwork = e.target.value;
            this.setState({collections});
          }.bind(this) } value={this.state.collections[key].artwork} placeholder="Enter Full URL" /></td>
          {key !== "none" && <td style={{textAlign: 'center'}}><Checkbox checked={this.state.collections[key].series} onChange={function() {
            let collections = this.state.collections;
            collections[key].series = collections[key].series ? !collections[key].series : true;
            this.setState({collections});
          }.bind(this)} /></td>}
          {key !== "none" && <td>
            <button className="blueButton" onClick={() => {
              let collections = this.state.collections;
              delete collections[key];
              remove('sermon_collections/' + key);
              this.setState({collections});
            }}>Remove</button>
          </td>}
        </tr>
      )
    });

    //console.log(this.state.featured);

    return (
      <Modal show={this.props.show} bsSize="large" onHide={() => this.props.done()}>
        <Modal.Header closeButton>
          <Modal.Title>Manage Collections</Modal.Title>
        </Modal.Header>

        <Modal.Body>

          <div style={{width: 250}}>
            <FormGroup key="group" controlId="group">
              <ControlLabel>Select Featured Collection</ControlLabel>
              <FormControl componentClass="select" value={this.state.featured} onChange={(e) => {
                post('sermon_collections/featured', this, e.target.value)
                this.setState({featured: e.target.value});
              }}>
                {Object.keys(this.state.collections).map(key => { return <option key={key} value={key}>{this.state.collections[key].name}</option>})}
              </FormControl>
            </FormGroup>
          </div>

          <table className="rsvpTable">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Priority</th>
                <th>Cover Image (1920 x 1080)</th>
                <th>Album Artwork (1400 x 1400)</th>
                <th>Series?</th>
              </tr>
            </thead>
            <tbody>
              {collectionRows}
              <tr>
                <td>+</td>
                <td><FormControl type="text" onChange={function(e) {
                  this.setState({newCollectionTitle: e.target.value});
                }.bind(this) } value={this.state.newCollectionTitle} placeholder="Enter New Collection Name"/></td>
                <td><FormControl componentClass="select" onChange={function(e) {
                  this.setState({newCollectionPriority: parseInt(e.target.value)});
                }.bind(this) } value={this.state.newCollectionPriority} placeholder="Priority"><option>1</option><option>2</option><option>3</option></FormControl></td>
                <td><FormControl type="text" onChange={function(e) {
                  this.setState({newCollectionImage: e.target.value});
                }.bind(this) } value={this.state.newCollectionImage} placeholder="Enter Full URL"/></td>
                <td><FormControl type="text" onChange={function(e) {
                  this.setState({newCollectionArtwork: e.target.value});
                }.bind(this) } value={this.state.newCollectionArtwork} placeholder="Enter Full URL"/></td>
                <td style={{textAlign: 'center'}}><Checkbox checked={this.state.newCollectionSeries} onChange={function() {
                  this.setState({newCollectionSeries: !this.state.newCollectionSeries});
                }.bind(this)} /></td>
                <td><button className="blueButton" onClick={() => {
                  let obj = {name: this.state.newCollectionTitle, image: this.state.newCollectionImage, artwork: this.state.newCollectionArtwork, series: this.state.newCollectionSeries, priority: this.state.newCollectionPriority};
                  push('sermon_collections', this, obj).then(newObj => {
                    let collections = this.state.collections;
                    collections[newObj.key] = {name: this.state.newCollectionTitle, image: this.state.newCollectionImage};
                    this.setState({collections, newCollectionTitle: "", newCollectionImage: "", newCollectionSeries: false, newCollectionPriority: 3});
                    window.sermon_collections = collections;
                  });
                }}>Add</button></td>
              </tr>
            </tbody>
          </table>

          <div style={{height: 10}} />
          <CCOAlert in={this.state.networkAlert} type="warning" title="Network Error" content="Could not save because we could not connect to the server, please try again later." />
        </Modal.Body>

        <Modal.Footer>
          <center>
            <div style={{width: 200}}>
              <CCOButton onClick={() => this.saveCollections()} text="Save" type="primary" />
            </div>
          </center>
        </Modal.Footer>
      </Modal>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/sermons/CollectionEditView.js
 **/